export default __webpack_public_path__ + "static/media/iQ4-logo-2.ff7c04eb.svg";